"use client";
import { memo, PropsWithChildren } from "react";
import { useResponsive } from "@onair/minimal-ui/hooks/use-responsive";
import Carousel from "./carousel";

interface PostListWraperClientProps extends PropsWithChildren {
	className?: string;
}
const PostListWraperClient: React.FC<PostListWraperClientProps> = ({
	children,
}) => {
	const isDownLg = useResponsive("down", "lg");

	if (isDownLg) {
		return <Carousel>{children}</Carousel>;
	}

	return (
		<div className="post-list-seconds grid grid-cols-4 gap-6">{children}</div>
	);
};
export default memo(PostListWraperClient);
